module.exports = __webpack_public_path__ + "3858e00338deda5915df2ea1618b00ad.svg";